export default __webpack_public_path__ + "static/media/decent.ea763d1a.jpg";